(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list-new/assets/javascripts/game-list-item.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list-new/assets/javascripts/game-list-item.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  Card,
  CardBody
} = svs.ui.ReactCard;
const GameListItem = _ref => {
  let {
    children,
    className = '',
    style = {},
    href = null,
    onClick = null,
    'aria-label': ariaLabel = null
  } = _ref;
  const cardProps = {
    branding: 'sport',
    className: "game-list-item ".concat(className),
    style
  };

  if (ariaLabel) {
    cardProps['aria-label'] = ariaLabel;
  }

  const handleKeyDown = event => {
    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick(event);
    }
  };

  if (href) {
    cardProps.href = href;
    cardProps.className += ' game-list-item-clickable';
  } else if (onClick) {
    cardProps.className += ' game-list-item-clickable';
    cardProps.style = _objectSpread(_objectSpread({}, cardProps.style), {}, {
      cursor: 'pointer'
    });
    cardProps.tabIndex = 0;
    cardProps.role = 'button';
  }
  const handleClick = onClick || undefined;
  const handleKeyDownEvent = onClick ? handleKeyDown : undefined;
  return React.createElement(Card, {
    "aria-label": cardProps['aria-label'],
    branding: cardProps.branding,
    className: cardProps.className,
    href: cardProps.href,
    onClick: handleClick,
    onKeyDown: handleKeyDownEvent,
    role: cardProps.role,
    style: cardProps.style,
    tabIndex: cardProps.tabIndex
  }, React.createElement(CardBody, null, children));
};
setGlobal('svs.components.marketplace.gameListNew.GameListItem', GameListItem);

 })(window);